<template>
  <div class="main-wrapper-container publication-page">
    <material-block/>
  </div>
</template>

<script>
import MaterialBlock from "@/components/entities/block/MaterialBlock.vue";

export default {
  name: "UpdateMaterialPage",
  components: {MaterialBlock}
}
</script>

<style scoped>

</style>
